import ReReferenceUnits from "../index";

export const referenceUnitConstants = {
	GetReferenceUnits: {
		REQUEST : 'GET_NRI_REFERENCE_UNITS_REQUEST',
		SUCCESS : 'GET_NRI_REFERENCE_UNITS_SUCCESS',
		FAILURE : 'GET_NRI_REFERENCE_UNITS_FAILURE'
	},
	ClearReferenceUnits: 'CLEAR_NRI_REFERENCE_UNITS',
}